(function () {
    'use strict';
    angular.module('app').service('iframeMessagingService', iframeMessagingService);
    iframeMessagingService.$inject = [
        '$window',
        '$location',
        '$rootScope'
    ];
    function iframeMessagingService($window, $location, $rootScope) {
        var service = {
            sendMessage: sendMessage,
            activate: initPostMsgListener
        };
        var validDomains = [
            'avanan.net',
            'avanan-dev.net',
            'checkpointcloudsec.com',
            'sonicwallcloudsec.com'
        ];
        function initPostMsgListener() {
            // Bind to window message event to get post message from iframe.
            var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
            var eventer = window[eventMethod];
            var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
            eventer(messageEvent, function (msg) {
                var isValidDomain = validDomains.filter(function (domain) {
                    return msg.origin.includes(domain);
                }).length > 0;
                if (!isValidDomain || !msg.data) {
                    return;
                }
                onIncomePostMsg(msg.data);
            }, false);
        }
        function onIncomePostMsg(action) {
            // When get post msg check the action type.
            switch (action.type) {
            case 'setThemeStyle':
                if (action.params) {
                    setTheme(action.params.themeName);
                }
                break;
            case 'postLinks':
                initPostLinks();
                break;
            }
        }
        function sendMessage(message) {
            // Send post messge to host application.
            if ($window.parent !== $window) {
                $window.parent.postMessage(message, '*');
            }
        }
        function initPostLinks() {
            // Send post message on every link click.
            $(document).on('click', 'a', function (event) {
                var url = $(this).attr('routerLink');
                if (url && url.length > 1) {
                    var msg = {
                        type: 'routerLink',
                        params: {
                            url: url,
                            target: $(this).attr('target')
                        }
                    };
                    service.sendMessage(msg);
                    return false;
                }
            });
            $(document).on('mouseenter', 'a', function (event) {
                var href = $(this).attr('href');
                if (href && href.length > 1) {
                    $(this).attr('routerLink', $(this).attr('href'));
                    $(this).removeAttr('href');
                    $(this).on('contextmenu', function (event) {
                        event.preventDefault();
                    });
                }
            });
        }
        function setTheme(cssThemeName) {
            $('body').addClass('ui2-style');
            $('body').addClass(cssThemeName);
        }
        initPostMsgListener();
        return service;
    }
}());